import React from 'react';
import {
  Modal,
  Alert,
  Button,
} from '@cochlear-design-system/foundation';
import { PatientRecordContext } from '../contexts/PatientRecordContext';
import { routes } from '../../../config';

export const EndOfServiceModal = () => {
  const { showEndOfServiceModal, setShowEndOfServiceModal, labels } =
    React.useContext(PatientRecordContext);

  return (
    <Modal
      show={showEndOfServiceModal}
      onHide={() => setShowEndOfServiceModal(false)}
      size="xl"
    >
      <Modal.Header
        closeButton
        data-analytics="close_end_of_service_modal"
      >
        <Modal.Title>
          {labels['labels.patientRecord.endOfServiceModal.title'] ||
            'End of its service life'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert heading="" show variant="info">
          {labels[
            'labels.patientRecord.endOfServiceModal.messagePart1'
          ] ||
            'This device has reached the end of its service life. Unfortunately, maintenance and repair services are no longer available. For upgrade options, please contact '}
          <a
            href={routes.customerService}
            target="_blank"
            rel="noreferrer"
          >
            {labels[
              'labels.patientRecord.endOfServiceModal.customerServiceLinkText'
            ] || 'Cochlear Customer Service'}
          </a>
          {labels[
            'labels.patientRecord.endOfServiceModal.messagePart2'
          ] || '.'}
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button
          text={
            labels['labels.patientRecord.endOfServiceModal.close'] ||
            'OK'
          }
          type="primary"
          onClick={() => setShowEndOfServiceModal(false)}
          data-analytics="close_end_of_service_modal_button"
        />
      </Modal.Footer>
    </Modal>
  );
};
